import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LogoUpload } from 'assets/js/pages/account-settings/account-about/LogoUpload';
import * as SettingsCard from 'components/settings-card';
import * as Tooltip from 'components/tooltip';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const LogosSettings = () => {
    const { logo, email_logo } = useCurrentAccount();

    return (
        <SettingsCard.Root>
            <SettingsCard.LeftSide>
                <SettingsCard.Heading>Logos</SettingsCard.Heading>
            </SettingsCard.LeftSide>
            <SettingsCard.RightSide className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                    <div>
                        <div className="flex items-center gap-1">
                            <p className="text-base font-medium">Main logo</p>
                            <Tooltip.Root>
                                <Tooltip.Trigger>
                                    <FontAwesomeIcon
                                        className="text-gray-600"
                                        icon={faQuestionCircle}
                                    />
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                    <Tooltip.Content inverse>
                                        <p>
                                            Recommended aspect ratio: 4:5 to 1.91:1 or square. Max
                                            Size: 5MB.
                                        </p>
                                        <Tooltip.Arrow inverse />
                                    </Tooltip.Content>
                                </Tooltip.Portal>
                            </Tooltip.Root>
                        </div>
                        <p className="text-sm text-gray-600">
                            Used on your campaign pages, landing page, etc.
                        </p>
                    </div>
                    <LogoUpload defaultUrl={logo ?? undefined} type="default" key={logo} />
                </div>
                <div className="flex flex-col gap-2">
                    <div>
                        <div className="flex items-center gap-1">
                            <p className="text-base font-medium">Email logo</p>
                            <Tooltip.Root>
                                <Tooltip.Trigger>
                                    <FontAwesomeIcon
                                        className="text-gray-600"
                                        icon={faQuestionCircle}
                                    />
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                    <Tooltip.Content inverse>
                                        <p>Max height: 300px. Max Size: 5MB.</p>
                                        <Tooltip.Arrow inverse />
                                    </Tooltip.Content>
                                </Tooltip.Portal>
                            </Tooltip.Root>
                        </div>
                        <p className="text-sm text-gray-600">Used in your custom-branded emails.</p>
                    </div>
                    <LogoUpload defaultUrl={email_logo?.url} type="email" key={email_logo?.url} />
                </div>
            </SettingsCard.RightSide>
        </SettingsCard.Root>
    );
};

export { LogosSettings };
